export default "__VITE_ASSET__84e26huF__"